import { useGetProjectListReports } from 'api-hooks/report';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import PivotReportTemplate from './components/pivot-report-template';

export default function ProjectListReport() {
  const { t } = useTranslation();

  return (
    <PivotReportTemplate
      title={t('common:project_list')}
      usePivotQuery={useGetProjectListReports}
      isShowAllFilterCompleted
    />
  );
}
